import { DateTimePicker, DSFormControlLabel, DSGrid, DSRadio } from '@deltasierra/components';
import { t } from '@deltasierra/shared';
import { FormikProps } from 'formik';
import React from 'react';
import { PublishToClubReadyStep1FormValues } from '../../../types/publish-to-club-ready-step-1-form-values';
import { StyledClubReadyRadioGroup } from '../../../../common';
import { ClubReadyListOptionBase } from './ClubReadyListOptionBase';

type ClubReadyActiveListOptionProps = {
    formik: FormikProps<PublishToClubReadyStep1FormValues>;
};

export function ClubReadyActiveListOption({ formik }: ClubReadyActiveListOptionProps): JSX.Element {
    return (
        <ClubReadyListOptionBase formik={formik} listKey="active" listName={t('BUILD.PUBLISH.CLUB_READY.ACTIVE')}>
            <StyledClubReadyRadioGroup
                value={formik.values.active.listChoice}
                onChange={value =>
                    formik.setFieldValue('active', {
                        ...formik.values.active,
                        listChoice: value.target.value as 'all' | 'withActivityAfter' | 'withActivityBefore',
                    })
                }
            >
                <DSFormControlLabel
                    control={<DSRadio />}
                    label={t('BUILD.PUBLISH.CLUB_READY.ALL_ACTIVE_MEMBERS')}
                    value="all"
                />
                <DSGrid container justifyContent="space-between">
                    <DSGrid item>
                        <DSFormControlLabel
                            control={<DSRadio />}
                            label={t('BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_BEFORE')}
                            value="withActivityBefore"
                        />
                    </DSGrid>
                    <DSGrid item>
                        <DateTimePicker
                            error={
                                !!formik.errors.active &&
                                formik.values.active.listChoice === 'withActivityBefore' &&
                                (formik.values.active.beforeDate === null || formik.values.active.beforeDate === '')
                            }
                            helperText={
                                formik.values.active.listChoice === 'withActivityBefore' ? formik.errors.active as string : ''
                            }
                            type="date"
                            value={formik.values.active.beforeDate ?? undefined}
                            onChange={value =>
                                formik.setFieldValue('active', {
                                    ...formik.values.active,
                                    beforeDate: value,
                                    listChoice: 'withActivityBefore',
                                })
                            }
                        />
                    </DSGrid>
                </DSGrid>
                <DSGrid container justifyContent="space-between">
                    <DSGrid>
                        <DSFormControlLabel
                            control={<DSRadio />}
                            label={t('BUILD.PUBLISH.CLUB_READY.WITH_ACTIVITY_AFTER')}
                            value="withActivityAfter"
                        />
                    </DSGrid>
                    <DSGrid>
                        <DateTimePicker
                            error={
                                !!formik.errors.active &&
                                formik.values.active.listChoice === 'withActivityAfter' &&
                                (formik.values.active.afterDate === null || formik.values.active.afterDate === '')
                            }
                            helperText={
                                formik.values.active.listChoice === 'withActivityAfter' ? formik.errors.active as string : ''
                            }
                            type="date"
                            value={formik.values.active.afterDate ?? undefined}
                            onChange={value =>
                                formik.setFieldValue('active', {
                                    ...formik.values.active,
                                    afterDate: value,
                                    listChoice: 'withActivityAfter',
                                })
                            }
                        />
                    </DSGrid>
                </DSGrid>
            </StyledClubReadyRadioGroup>
        </ClubReadyListOptionBase>
    );
}
ClubReadyActiveListOption.displayName = 'ClubReadyListOptions';
